<template>
    <keep-alive>
        <component :is="layout">
            <router-view/>
            <Loader />
        </component>
    </keep-alive>
</template>
<script>

export default {
    data: () => {
        return {
            start_auth: false
        }
    },
    computed: {
        layout() {
            return this.$route.meta.layout
        },
        readyForRequests() {
            return this.$store.getters.readyForRequests
        }
    },
    components: {
        Empty: () => import('@/layouts/Empty'),
        Main: () => import('@/layouts/Main'),
        Loader: () => import('@/components/Loader'),
        Simple: () => import('@/layouts/Simple'),
        Admin: () => import('@/layouts/Admin')
    },
    methods: {
        initWebviewListener() {
            window.setWebViewMode = async () => {
                this.$store.dispatch('setWebviewMode')
            }
            window.setDevice = async ({token, platform}) => {
                window.ReactNativeWebView 
                    ? window.ReactNativeWebView.postMessage(JSON.stringify({method: 'start set device'}))
                    : '';
                let result = await this.$axios.post('api/account/device/add', { device: { token, platform } });
                window.ReactNativeWebView 
                    ? window.ReactNativeWebView.postMessage(JSON.stringify({method: 'device', params: result}))
                    : '';
                
            }
            try {
                window.ReactNativeWebView 
                    ? window.ReactNativeWebView.postMessage(JSON.stringify({method: 'ready'}))
                    : '';
                
            } catch (error) {
                console.log(error)
            }
        },
        takeReadyForReq(val) {
            if (val && !this.start_auth) {
                try {
                    window.ReactNativeWebView 
                        ? window.ReactNativeWebView.postMessage(JSON.stringify({method: 'readyForRequests'}))
                        : '';
                    window.deleteDevice = async (params) => {
                        await this.$axios.post('/api/account/device/delete', params)
                        this.$store.dispatch('logout'),
                        this.$router.push('/login'),
                        this.$router.go()
                    }
                } catch (error) {
                    console.log(error,'e');
                }
            }
        }
    },
    watch: {
        readyForRequests: 'takeReadyForReq'
    },
    mounted() {
        this.$nextTick(document.querySelector('.app-preloader').classList.add('hidden'))
    },
    created () {
        this.initWebviewListener()
    }
}
</script>
<style lang="stylus">
@import './assets/styles/common';
</style>
